import { Component } from '@angular/core';

@Component({
  selector: 'iq-central-front-end-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'iqc-homepage';
}
